// ----------------------------------------------------------------------------
// Component: Image Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_image-banner.scss';
